import CommonDialog from "./CommonDialog";

export default CommonDialog;
